export default () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 6.5C7.433 6.5 9 8.067 9 10V14C9 14.8284 8.32843 15.5 7.5 15.5H3.5C2.67157 15.5 2 14.8284 2 14V10C2 8.067 3.567 6.5 5.5 6.5Z"
      fill="#527195"
      stroke="#527195"
    />
    <path
      d="M16.5 6.5C18.433 6.5 20 8.067 20 10V14C20 14.8284 19.3284 15.5 18.5 15.5H14.5C13.6716 15.5 13 14.8284 13 14V10C13 8.067 14.567 6.5 16.5 6.5Z"
      fill="#527195"
      stroke="#527195"
    />
    <path d="M9.5 2V20" stroke="#527195" />
    <path d="M12.5 2V20" stroke="#527195" />
  </svg>
)
